import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SurveyState {
  preSurveyId: string | null
  postSurveyId: string | null
  post90SurveyId: string | null
  naloxoneSurveyId: string | null
  naloxoneSurveyIdLoaded: boolean
  loaded: boolean
}

export const surveyInitialState: SurveyState = {
  preSurveyId: null,
  postSurveyId: null,
  post90SurveyId: null,
  naloxoneSurveyId: null,
  naloxoneSurveyIdLoaded: false,
  loaded: false
}

export const surveySlice = createSlice({
  name: 'survey',
  initialState: surveyInitialState,
  reducers: {
    setSurveyIds: (state, action: PayloadAction<{ preSurveyId: string, postSurveyId: string, post90SurveyId: string }>) => {
      state.preSurveyId = action.payload.preSurveyId
      state.postSurveyId = action.payload.postSurveyId
      state.post90SurveyId = action.payload.post90SurveyId
      state.loaded = true
    },
    // Recorded even when id is null, so the guard doesn't refetch on every check.
    setNaloxoneSurveyId: (state, action: PayloadAction<string | null>) => {
      state.naloxoneSurveyId = action.payload
      state.naloxoneSurveyIdLoaded = true
    }
  }
})

export const {
  setSurveyIds,
  setNaloxoneSurveyId
} = surveySlice.actions

export default surveySlice.reducer
